import React from "react";
import trLogoWhite from "../images/trLogoWhite.png";
import Layout from "../components/layout";
import { Link } from "gatsby";
import casa from "../images/casa.png";
import casa2 from "../images/casa2.png";
import casa3 from "../images/casa3.png";
import casa4 from "../images/casa4.png";

import TransitionLink from "gatsby-plugin-transition-link";
import AniLink from "gatsby-plugin-transition-link/AniLink";

const IndexPage = () => (
  <Layout>
    <div className="clouds-landing">
      <img src={casa4} className="cloud-7" />
      <img src={casa2} className="cloud-1" />
      <img src={casa3} className="cloud-2" />
      <img src={casa} className="cloud-3" />
      <img src={casa4} className="cloud-4" />
      <img src={casa} className="cloud-5" />
      <img src={casa4} className="cloud-6" />
      <img src={casa3} className="cloud-8" />
    </div>

    <div className="hero-body">
      <div className="columns pt-0">
        <div className="column is-7 is-offset-3 welcome">
          <div className="container center">
            <div className="content" style={{ marginTop: "-30px" }}>
              <div className="columns">
                <div className=" center is-5 is-offset-1 column box-primary">
                  <img src={trLogoWhite} />
                </div>
                <div className="column  is-5 box-secondary">
                  <div className="mt-1 has-text-centered is-mobile is-size-6 text-uppercase has-text-white">
                    PARA ARRENDATARIOS
                  </div>
                </div>
              </div>
              <h1 className="mt-6 is-size-4 has-text-centered has-text-weight-normal ">
                <span className="is-capitalized">
                  <b>
                    LA PRIMERA PÓLIZA DE GARANTÍA EMITIDA POR UNA COMPAÑÍA DE
                    SEGUROS QUE TE PERMITE NO DESEMBOLSAR EL MES DE GARANTÍA
                  </b>
                  <br />
                  <br />
                </span>
                <b>Arrienda sin inmovilizar</b> 1 o 2 meses de garantía en
                efectivo, paga solo una pequeña prima anual para cumplir con las
                exigencias del propietario.
                <br />
                <br />
                {/*   <b>Dispone de tu dinero</b> como lo desees */}
              </h1>
              <br />
              <div className="is-size-12 has-text-centered">
                <AniLink
                  paintDrip
                  hex="#fec200"
                  to="step-1"
                  className="button is-large is-warning is-inverted is-outlined "
                >
                  COTIZA AQUI
                </AniLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default IndexPage;
